import Vue from 'vue'
import AppConfig from '../../config/AppConfig.js'
// import emoji_config from '../config/emoji_config.js'
import Emoji from '../util/emoji.js'
import {formatFileSize} from '../functions/Common.js'


// 过滤器
Vue.filter('connectHost', function (value) {
  if (!value) return ''
  value = value.toString()
  if(value.indexOf('http') === -1){
	  return AppConfig.host + value
  }
  return value
})

// 最近聊天时间
Vue.filter('rechentDate', function (time) {
	if (!time) return ''
	if(time.toString().length == 10){
		time = time*1000
	}
	let sendDate = new Date(time)
	let currentDate = new Date()
	let years = sendDate.getFullYear()
	let month = sendDate.getMonth()+1
	let day = sendDate.getDate()
	let hours = sendDate.getHours()
	let minute = sendDate.getMinutes()
	month = month<10 ? '0' + month : month
	day = day < 10 ? '0' + day : day
	hours = hours<10 ? '0' + hours : hours
	minute = minute < 10 ? '0' + minute : minute
	let formatTime = ''
	let zeroTime = new Date(currentDate.toLocaleDateString()).getTime()
	let time_diff = currentDate.getTime() - sendDate.getTime()
	let toZeroTime = currentDate.getTime() - zeroTime
	if(time_diff > 0 && time_diff <= toZeroTime){
		formatTime = hours + ':' + minute
	}else if(time_diff > toZeroTime && time_diff<=(86400000*6+toZeroTime)){
		formatTime = Math.ceil(time_diff/86400000) + '天前'
	}else{
		formatTime = month + "-" + day
	}
	return formatTime
})

//  转换时间，将时间戳转换为YYYY-MM-DD HH:mm:ss格式的
Vue.filter('formatTimeToYMDHms', function (time) {
	if(time.toString().length === 10){
		time = parseInt(time) * 1000
	}
	let date = new Date(time)
	let years = date.getFullYear()
	let month = date.getMonth()+1
	let day = date.getDate()
	let hours = date.getHours()
	let minute = date.getMinutes()
	let second = date.getSeconds()
	month = month<10 ? '0' + month : month
	day = day < 10 ? '0' + day : day
	hours = hours<10 ? '0' + hours : hours
	minute = minute < 10 ? '0' + minute : minute,
	second = second < 10 ? '0' + second : second
	return years + '-' + month + '-' + day + ' ' + hours + ':' + minute + ':' + second
})

// 过滤器-过滤数值，大于99用...表示
Vue.filter('pass99', function (value) {
  if (!value) return ''
  value = parseInt(value)
  if(value > 99){
	  return '···' 
  }
  return value
})

/**
 * 格式化最近聊天表中的最后一条消息
 * @param {Object} message 原消息
 * @param {Object} type 消息类型
 */
Vue.filter('formatRMsg', function (message,type) {
	let conent = message
	switch(type){
		case 'image':
			conent = '[图片消息]'
			break;
		case 'voice':
			conent = '[语音消息]'
			break;
		case 'video':
			conent = '[视频消息]'
			break;
		case 'program':
			conent = '[小程序消息]'
			break;
		case 'red_package':
			conent = '[红包消息]'
			break;
		case 'red_package_d':
			conent = '[红包消息]'
			break;
		case 'transfer_accounts':
			conent = '[转账消息]'
			break;
		case 'transfer_accounts_d':
			conent = '[转账消息]'
			break;
		case 'file':
			conent = '[文件消息]'
			break;
		case 'link':
			try{
				let cotentObj = JSON.parse(conent)
				conent = '[链接]'+cotentObj.link_title
			}catch(e){
				// console.log(e);
			}
			break;
		case 'finder':
			conent = '[视频号消息]'
			break;
		case 'finder_live':
			conent = '[视频直播消息]'
			break;
		case 'position':
			conent = '[位置消息]'
			break;
	}
	return conent.replace(/\<br\/\>/g,' ')
})

/**
 * 格式化聊天内容
 * @param {Object} message 原消息
 * @param {Object} type 消息类型
 */
Vue.filter('formatMsg', function (message,type) {
	let conent = ""
	switch(type){
		case 'text':
			conent = formatText(message)
			break;
		case 'image':
			conent = formatImage(message)
			break;
		case 'voice':
			conent = formatVoice(message)
			break;
		case 'video':
			conent = formatVideo(message)
			break;
		case 'program':
			conent = formatProgram(message)
			break;
		case 'red_package':
			conent = formatRedPackage(message)
			break;
		case 'red_package_d':
			conent = formatRedPackageD(message)
			break;
		case 'transfer_accounts':
			conent = formatTransferAccounts(message)
			break;
		case 'transfer_accounts_d':
			conent = formatTransferAccountsD(message)
			break;
		case 'file':
			conent = formatFile(message)
			break;
		case 'link':
			conent = formatLink(message)
			break;
		case 'finder':
			conent = formatFinder(message)
			break;
		case 'finder_live':
			conent = formatFinderLive(message)
			break;
		default:
			conent = message
	}
	return conent
})

// 格式化文本
function formatText(message){
	if (message == undefined || message == ''){
	        return message;
	}
	let emoji_array = message.match(/(\[(.+?)\]|[\uE40C\uE412\uE409\uE40D\uE107\uE403\uE40E\uE41D\uE14C\uE312\uE112]+?)/g)
	let __message = message;
	// 替换普通表情
	if (emoji_array != null){
		for (let i = 0;i<emoji_array.length;i++){
			let __message_temp = emoji_array[i]
			let emoji_pic = getEmojiImg(emoji_array[i].substring(1,emoji_array[i].length-1))
			if (emoji_pic != ''){
				__message_temp = '<img src="'+emoji_pic+'" style="width: 24px;height: 24px;">'
			}
			__message = __message.replace(emoji_array[i],__message_temp);
		}
	}
	return rn_to_br(__message)
}

// 格式化图片
function formatImage(message){
	if(message.indexOf('http') === -1){
		  message = AppConfig.host + message
	}else{
		if(message.indexOf('?x-oss-process=style') === -1){
			message += '?x-oss-process=style/thumb_w200'
		}
	}
	let content = '<div style="max-width:100%;background-color: #FFFFFF;"><image src="'+message+'" style="max-width:200px;cursor: pointer;"></div>'
	return content
}

// 格式化语音
function formatVoice(message){
	if(message.indexOf('http') === -1){
		  message = AppConfig.host + message
	}
	return '<div class="chat-voice"><span class="voice"></span></div>'
}

// 格式化视频
function formatVideo(message){
	if(message.indexOf('http') === -1){
		  message = AppConfig.host + message
	}
	return '<video class="video" controls="controls" width="320" height="240" ><source src="'+message+'" type="video/mp4"></video>'
}

// 格式化小程序
function formatProgram(message){
	try{
		let temp = JSON.parse(message);
		message = '<div class="chat-program">';
		message += '<div class="chat-program-title"><img src="'+temp.iconUrl+'" alt=""><span>'+temp.nickname+'</span></div>';
		message += '<div class="chat-program-desc">'+temp.title+'</div>';
		message += '<div class="chat-program-big"><img src="'+temp.hDj+'" alt=""></div>';
		message += '<div class="chat-program-footer"><span class="chat-program-link"></span><span>小程序</span></div>';
		message += '</div>';
	}catch (e) {
		message = '未知格式小程序消息';
	}
	return message
}

// 格式化红包-待领取
function formatRedPackage(message){
	try {
		let obj = JSON.parse(message);
		message = '<div class="red-package">\n' +
			'            <div class="red-package-info">\n' +
			'                <span class="red-package-img"></span>\n' +
			'                <span class="red-package-text">'+obj.receivertitle+'</span>\n' +
			'            </div>\n' +
			'            <div class="red-package-footer">\n' +
			'                <span>微信红包</span>\n' +
			'            </div>\n' +
			'        </div>';
	}catch (e) {
		message = '未知格式红包消息，请在手机端查看';
	}
	return message
}

// 格式化红包-已领取
function formatRedPackageD(message){
	try {
		let obj = JSON.parse(message);
		message = '<div class="red-package-d">\n' +
			'            <div class="red-package-d-info">\n' +
			'                <span class="red-package-d-img"></span>\n' +
			'                <span class="red-package-d-text">'+obj.receivertitle+'<br/>已领取</span>\n' +
			'            </div>\n' +
			'            <div class="red-package-d-footer">\n' +
			'                <span>微信红包</span>\n' +
			'            </div>\n' +
			'        </div>';
	}catch (e) {
		message = '未知格式红包消息，请在手机端查看';
	}
	return message
}

// 格式化转账消息-待领取
function formatTransferAccounts(message){
	try {
		let obj = JSON.parse(message);
		if(obj.pay_memo === ''){
			obj.pay_memo = '转账给你';
		}
		message = '<div class="transfer-accounts">\n' +
			'            <div class="transfer-accounts-info">\n' +
			'                <span class="transfer-accounts-img"></span>\n' +
			'                <span class="transfer-accounts-text">'+obj.money+'<br/>'+obj.pay_memo+'</span>\n' +
			'            </div>\n' +
			'            <div class="transfer-accounts-footer">\n' +
			'                <span>微信转账</span>\n' +
			'            </div>\n' +
			'        </div>';
	}catch (e) {
		message = '未知格式转账消息，请在手机端查看';
	}
	return message
}

// 格式化转账消息-已领取
function formatTransferAccountsD(message){
	try {
		let obj = JSON.parse(message);
		message = '<div class="transfer-accounts-d">\n' +
			'            <div class="transfer-accounts-d-info">\n' +
			'                <span class="transfer-accounts-d-img"></span>\n' +
			'                <span class="transfer-accounts-d-text">'+obj.money+'<br/>已收钱</span>\n' +
			'            </div>\n' +
			'            <div class="transfer-accounts-d-footer">\n' +
			'                <span>微信转账</span>\n' +
			'            </div>\n' +
			'        </div>';
	}catch (e) {
		message = '未知格式转账消息，请在手机端查看';
	}
	return message
}

// 格式化文件消息
function formatFile(message){
	try {
		let obj = JSON.parse(message);
		let icon_class = ''
		if(obj.suffix === 'txt'){
			icon_class = 'chat-file-icon-txt'
		}else if(obj.suffix === 'pdf'){
			icon_class = 'chat-file-icon-pdf'
		}else if(obj.suffix.indexOf('doc') !== -1){
			icon_class = 'chat-file-icon-doc'
		}else if(obj.suffix.indexOf('ppt') !== -1){
			icon_class = 'chat-file-icon-ppt'
		}else if(obj.suffix.indexOf('xls') !== -1){
			icon_class = 'chat-file-icon-xls'
		}
		message = '<div class="chat-file">\n'+
			'			<div class="chat-file-info">'+
			'				<p>'+obj.name+'</p>'+
			'				<p>'+formatFileSize(obj.size)+'</p>'+
			'			</div>'+
			'			<div class="chat-file-icon '+ icon_class +'"></div>'+
			'		</div>'
	}catch (e) {
		message = '未知文件格式消息，请在手机端查看';
	}
	return message
}

// 格式化链接消息
function formatLink(message){
	try {
		let obj = JSON.parse(message);
		let linkImg = (obj.link_img === undefined || obj.link_img === "") ? "/img/link-big-8a.png" : obj.link_img
		message = '<div class="chat-link">\n'+
			'			<div class="chat-link-title">'+
			'				<p>'+obj.link_title+'</p>'+
			'			</div>'+
			'			<div class="chat-link-info">'+
			'				<p>'+obj.link_desc+'</p>'+
			'				<img src="'+ linkImg +'"/>'+
			'			</div>'+
			'			<div class="chat-link-tip">'+
			'				<img src="/img/link-big-8a.png"/>'+
			'				<p>普通链接</p>'+
			'			</div>'+
			'		</div>'
	}catch (e) {
		message = '未知文件格式消息，请在手机端查看';
	}
	return message
}

// 格式化视频号消息
function formatFinder(message){
	try {
		let obj = JSON.parse(message)
		let finderThumb = obj.thumbUrl
		let finderAvatar = obj.avatar
		let finderDesc = obj.desc !== undefined ?  obj.desc : ''
		let finderNickname = obj.nickname !== undefined ? obj.nickname : '昵称为空'
		message = '<div class="chat-finder">\n'+
			'			<div class="chat-finder-img">'+
			'				<img src="'+finderThumb+'" class="chat-finder-thumb" />'+
			'				<img src="/img/video_play.png"  class="chat-finder-play"/>'+
			'			</div>'+
			'			<div class="chat-finder-info">'+
			'				<img src="'+ finderAvatar +'"/>'+
			'				<p>'+finderNickname+'</p>'+
			'			</div>'+
			'			<div class="chat-finder-desc">'+
			'				<p>'+finderDesc+'</p>'+
			'			</div>'+
			'			<div class="chat-finder-tip">'+
			'				<img src="/img/finder.png"/>'+
			'				<p>视频号</p>'+
			'			</div>'+
			'		</div>'
	}catch (e) {
		message = '未知文件格式消息，请在手机端查看';
	}
	return message	
}


// 格式化视频号直播消息
function formatFinderLive(message){
	try {
		let obj = JSON.parse(message)
		let finderThumb = obj.coverUrl
		let finderAvatar = obj.headUrl
		let finderDesc = obj.desc1 !== undefined ?  obj.desc1 : ''
		let finderNickname = obj.nickname !== undefined ? obj.nickname : '昵称为空'
		message = '<div class="chat-finder">\n'+
			'			<div class="chat-finder-img">'+
			'				<img src="'+finderThumb+'" class="chat-finder-thumb" />'+
			'				<img src="/img/video_play.png"  class="chat-finder-play"/>'+
			'			</div>'+
			'			<div class="chat-finder-info">'+
			'				<img src="'+ finderAvatar +'"/>'+
			'				<p>'+finderNickname+'</p>'+
			'			</div>'
		if(finderDesc !== ''){
			message += '<div class="chat-finder-desc">'+
			'				<p>'+finderDesc+'</p>'+
			'			</div>'
		}
		message +=  '	<div class="chat-finder-tip">'+
					'	    <img src="/img/finder.png"/>'+
					'		<p>视频号直播</p>'+
					'	</div>'+
					'</div>'
	}catch (e) {
		message = '未知文件格式消息，请在手机端查看';
	}
	return message	
}

// 查找表情图片位置
function getEmojiImg(name){
	let path = '';
	for(let i in Emoji.emoji){
		if(name == Emoji.emoji[i]){
			path = Emoji.path + i + '.png'
			break
		}
	}
	return path
}

// 转换空格、空白
function rn_to_br(strValue){
    return strValue.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, ' ');
}

export default {
	
}